import React from 'react';
import './LegalPages.css';

const Safety = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <header className="legal-header">
          <h1>Safety Guidelines</h1>
          <p className="legal-last-updated">Your safety is our priority</p>
        </header>

        <div className="legal-content">
          <section>
            <h2>Meeting New People Safely</h2>
            <p>The Interconnector connects you with new people in your community. While most interactions are positive, it's important to prioritize your safety when meeting new people.</p>
            
            <h3>First Meetings</h3>
            <ul>
              <li><strong>Meet in public places</strong> - Choose busy, well-lit public locations like cafes, restaurants, or community centers</li>
              <li><strong>Tell someone where you're going</strong> - Let a friend or family member know who you're meeting, where, and when</li>
              <li><strong>Bring a friend</strong> - Consider bringing someone you trust to group meetups</li>
              <li><strong>Stay sober</strong> - Keep a clear head during first meetings</li>
              <li><strong>Trust your instincts</strong> - If something feels off, it's okay to leave</li>
            </ul>
          </section>

          <section>
            <h2>Online Safety</h2>
            <h3>Sharing Personal Information</h3>
            <ul>
              <li><strong>Be cautious with personal details</strong> - Don't share your home address, workplace, or financial information early on</li>
              <li><strong>Use the platform's messaging</strong> - Keep initial conversations within The Interconnector's messaging system</li>
              <li><strong>Verify identities</strong> - Be wary of profiles that seem too good to be true or lack detailed information</li>
              <li><strong>Protect your social media</strong> - Review your privacy settings before connecting on other platforms</li>
            </ul>

            <h3>Red Flags to Watch For</h3>
            <ul>
              <li>Requests for money or financial information</li>
              <li>Pressure to meet immediately or in private locations</li>
              <li>Inconsistent information about themselves</li>
              <li>Refusal to video chat or meet in public</li>
              <li>Aggressive or inappropriate language</li>
              <li>Attempts to move conversations off the platform immediately</li>
            </ul>
          </section>

          <section>
            <h2>Group Safety</h2>
            <h3>Community Groups and Events</h3>
            <ul>
              <li><strong>Verify group legitimacy</strong> - Research the community organization or group leader</li>
              <li><strong>Start small</strong> - Attend smaller gatherings before larger events</li>
              <li><strong>Have an exit plan</strong> - Know how you'll get home and have backup transportation</li>
              <li><strong>Stay with the group</strong> - Don't leave with someone you've just met</li>
            </ul>
          </section>

          <section>
            <h2>Digital Safety</h2>
            <h3>Protecting Your Account</h3>
            <ul>
              <li><strong>Use a strong password</strong> - Create a unique, complex password for your account</li>
              <li><strong>Log out on shared devices</strong> - Always log out when using public or shared computers</li>
              <li><strong>Review your profile</strong> - Regularly check what information is visible to others</li>
              <li><strong>Report suspicious activity</strong> - Contact us immediately if you notice unauthorized access</li>
            </ul>
          </section>

          <section>
            <h2>Emotional Safety</h2>
            <h3>Setting Boundaries</h3>
            <ul>
              <li><strong>It's okay to say no</strong> - You're never obligated to meet or continue talking with someone</li>
              <li><strong>Take your time</strong> - Don't feel pressured to move relationships forward quickly</li>
              <li><strong>Communicate your limits</strong> - Be clear about your boundaries and expectations</li>
              <li><strong>Seek support</strong> - Talk to friends, family, or professionals if you feel overwhelmed</li>
            </ul>
          </section>

          <section>
            <h2>What We Do to Keep You Safe</h2>
            <ul>
              <li>Community guidelines and terms of service that all members must follow</li>
              <li>Reporting and blocking features for problematic users</li>
              <li>Manual review of reported accounts and content</li>
              <li>Secure data handling and privacy protection</li>
              <li>Regular safety updates and communication</li>
            </ul>
          </section>

          <section>
            <h2>Reporting and Support</h2>
            <h3>How to Report Issues</h3>
            <p>If you encounter any safety concerns, inappropriate behavior, or suspicious activity:</p>
            <ul>
              <li><strong>Use our reporting tools</strong> - Report users directly through their profiles</li>
              <li><strong>Contact us directly</strong> - Email james@theinterconnector.com with details</li>
              <li><strong>Block problematic users</strong> - Use our blocking feature to prevent further contact</li>
              <li><strong>Contact authorities</strong> - For serious threats or illegal activity, contact local police</li>
            </ul>

            <h3>Emergency Situations</h3>
            <p>If you're in immediate danger:</p>
            <ul>
              <li><strong>Call emergency services</strong> - In the UK, call 999</li>
              <li><strong>Get to safety</strong> - Move to a public place or safe location</li>
              <li><strong>Contact someone you trust</strong> - Reach out to friends, family, or support services</li>
            </ul>
          </section>

          <section>
            <h2>Additional Resources</h2>
            <h3>UK Safety Resources</h3>
            <ul>
              <li><strong>National Domestic Abuse Helpline:</strong> 0808 2000 247</li>
              <li><strong>Samaritans:</strong> 116 123 (free from any phone)</li>
              <li><strong>Victim Support:</strong> 08 08 16 89 111</li>
              <li><strong>Mind (Mental Health):</strong> 0300 123 3393</li>
            </ul>
          </section>

          <section>
            <h2>Remember</h2>
            <p><strong>Your safety comes first.</strong> While The Interconnector aims to create positive connections, we acknowledge that meeting new people carries inherent risks. Trust your instincts, take precautions, and don't hesitate to prioritize your wellbeing over social connections.</p>
            
            <p>Most people using The Interconnector are genuine individuals looking to build meaningful community connections. By following these guidelines and staying alert, you can help ensure positive and safe experiences for everyone.</p>
          </section>

          <section>
            <h2>Contact Us</h2>
            <p>
              If you have safety concerns or questions about these guidelines:
              <br />
              Email: james@theinterconnector.com
              <br />
              We take all safety reports seriously and will respond promptly.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Safety;